import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Provider } from 'react-redux';
import store from '../store';
import theme from '../../theme/theme';

const AppProviders = ({ children }) => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  </Provider>
);

export default AppProviders;
